import { useEffect } from "react";

interface PlayModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
}

export default function PlayModal({ open, title, onClose }: PlayModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-primary-950/70 p-4 animate-fade-in">
      <div className="w-full max-w-3xl overflow-hidden rounded-lg bg-background-50">
        <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
          <h3 className="flex items-center gap-2 font-heading text-base font-semibold text-foreground-900">
            <i className="ri-play-circle-line text-primary-600" />
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭播放器"
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-500 transition-colors hover:bg-background-100 hover:text-foreground-900"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="relative flex aspect-video w-full flex-col items-center justify-center bg-primary-950 text-center">
          <div className="absolute inset-0 opacity-30">
            <div className="h-full w-full bg-[radial-gradient(circle_at_50%_40%,_oklch(var(--secondary-600))_0%,_transparent_60%)]" />
          </div>
          <span className="relative flex h-16 w-16 items-center justify-center rounded-full bg-background-50/15 text-background-50">
            <i className="ri-loader-4-line animate-spin text-3xl" />
          </span>
          <p className="relative mt-4 font-heading text-lg font-semibold text-background-50">
            演示播放器
          </p>
          <p className="relative mt-1 max-w-md px-6 text-sm text-background-200/80">
            当前为前端演示模式，暂未接入真实视频资源。播放功能及资源接口将在后续版本中支持。
          </p>
          <div className="relative mt-5 flex items-center gap-3">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/15 text-background-50">
              <i className="ri-play-fill" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/15 text-background-50">
              <i className="ri-volume-up-line" />
            </span>
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/15 text-background-50">
              <i className="ri-fullscreen-line" />
            </span>
          </div>
        </div>

        <div className="flex items-center justify-between gap-3 px-4 py-3">
          <p className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-information-line text-accent-600" />
            演示资源 · 仅作展示用途
          </p>
          <button
            type="button"
            onClick={onClose}
            className="whitespace-nowrap rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
          >
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
}